<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stocksSelected"
    :clearable="!unclearable"
    chips
    multiple
    deletable-chips
    small-chips
    :items="stocksItems"
    :loading="stocksLoading"
    :search-input.sync="stocksSearch"
    item-text="Description"
    item-value="id"
    :label="noLabel ? '' : label ? label : $t('Stock.ObjectName')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import Stocks from "@/api/stocks";

export default {
  name: "SearcherStocks",

  props: {
    value: Array,
    stockDistrict: Object,
    noLabel: Boolean,
    label: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    stockTypes: Array,
    stock_ids: String,
    identityType: Array,
  },

  computed: {
    stocksItems() {
      var stocks;
      if (this.stockDistrict) {
        stocks = this.stocks.filter(
          (stock) => stock.stock_district_code == this.stockDistrict.code
        );
      } else {
        stocks = this.stocks;
      }
      return stocks.map((stock) => {
        const Description = stock.code + " / " + stock.name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == stock.id
            )
          : false;
        return Object.assign({}, stock, { Description, disabled });
      });
    },
  },

  data: () => ({
    stocks: [],
    stocksLoading: false,
    stocksSearch: "",
    stocksSelected: [],
  }),

  mounted() {
    this.stocksLoading = true;
    Stocks.fetchAllForSelect({ types: this.stockTypes, identity_type: this.identityType })
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = response.data.stocks;
            if (this.$route.query.stock_ids) {
              let numArr = this.$route.query.stock_ids.split(","); // [x,x,x,x]
              let new1 = numArr.map((item) => {
                return { id: item };
              });
              // 过滤出 this.stocks 中id为 numArr 的数据
              let newArr = this.stocks.filter((item) =>
                new1.some((v) => v.id == item.id)
              );
              this.stocksSelected = newArr;
            }
            if (this.stock_ids) {
              let numArr = this.stock_ids.split(","); // [x,x,x,x]
              let new1 = numArr.map((item) => {
                return { id: item };
              });
              // 过滤出 this.stocks 中id为 numArr 的数据
              let newArr = this.stocks.filter((item) =>
                      new1.some((v) => v.id == item.id)
              );
              this.stocksSelected = newArr;
            }
          }
          this.stocksLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.stocksLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stocksSelected = this.value;
      },
    },
    stocksSelected: {
      handler() {
        this.$emit("input", this.stocksSelected);
      },
    },
  },
};
</script>